<template>
    <div>
        <a-modal
            title="上传物料"
            width="704px"
            class="materialPushing"
            :zIndex="1001"
            v-model="changeMaterialModal">
            <a-alert class="warn-box" message="一旦发现有上传涉毒、涉黄、涉黑等违法内容，将永久关闭后台账号，并向公安机关举报！" type="warning" show-icon />
            <div class="modal_content">
                <div class="radio">
                    <span>播放时长：</span>
                     <span>{{playDuration || 0}} 秒</span>
                </div>
                <div class="content_main">
                    <div class="content_warp" v-for="(key,index) in changeMaterialList" :key="index" v-if="key.fileUrl || index === 1 && !key.fileUrl">
                        <div class="change_material_body">
                            <a-spin :spinning="index === 1 ? fullImgLoading : false" tip="正在上传...">
                                <!-- 图片未上传时不显示旧图片 -->
                                <a-upload
                                    v-if="index === 1 && !key.fileUrl"
                                    :src="key.fileUrl"
                                    name="file"
                                    listType="picture-card"
                                    class=""
                                    :showUploadList="false"
                                    :action="uploadMaterialImgUrl"
                                    :beforeUpload="beforeUploadFun"
                                    :headers="header"
                                    @change="changeMaterialFun">
                                    <div class="m-updataing">
                                        <div class="u-ant-upload-img">
                                            <a-icon type="picture" width="35px" height="28px"/>
                                        </div>
                                        <div class="u-ant-upload-text">点击上传</div>
                                        <div class="u-ant-upload-info">
                                            尺寸:{{key.materialSize.w}}px
                                            *{{key.materialSize.h}}px
                                        </div>
                                        <!-- <div class="u-ant-upload-info">格式:jpg、png、mp4</div>
                                        <div class="u-ant-upload-info">图片不大于1mb，视频不大于30mb</div> -->
                                    </div>
                                </a-upload>
                                <div v-if="key.fileUrl" class="m-updataed">
                                    <div class="m-bg-img">
                                        <img :src="key.fileUrl" v-if="key.fileType === 1"/>
                                        <video :src="key.fileUrl" controls="controls" v-else></video>
                                    </div>
                                    <div class="m-img-info" @click.stop="previewMaterial(key.fileType,key.fileUrl)">
                                        <a-icon class="u-clost-updata" type="close-circle" theme="filled" v-if="index === 1"
                                                @click.stop="changeDelMaterial"/>
                                    </div>
                                </div>
                            </a-spin>
                        </div>
                        <span v-if="key.fileUrl || index" :class="index ? 'span_new' : 'span_old'">{{index ? '新' : '旧'}}</span>
                    </div>
                </div>
            </div>
            <div slot="footer">
                <a-button key="back" @click="changeMaterialModal = false">取消</a-button>
                <a-button key="submit" type="primary" @click="savePlan" :disabled="fullImgLoading">保存</a-button>
            </div>
        </a-modal>
        <!--更换物料历史-->
        <a-modal title="换画记录"
                 v-model="materialHistoryModal"
                 width="668px">
            <div>
                <a-table :columns="materialHistoryColumns" :dataSource="materialHistoryList" class="material_history_table" :pagination="false">
                    <template slot="beforeUrl" slot-scope="row">
                        <span class="show_btn" @click="showHistoryMaterial(row.beforeUrl)">
                            查看物料
                        </span>
                    </template>
                    <template slot="afterUrl" slot-scope="row">
                        <span class="show_btn" @click="showHistoryMaterial(row.afterUrl)">
                            查看物料
                        </span>
                    </template>
                    <template slot="auditResult" slot-scope="row">
                        <span v-if="row.auditResult === -1"><a-badge status="error"/>不通过</span>
                        <span v-else-if="row.auditResult === 1"><a-badge status="success"/>通过</span>
                        <span v-else>--</span>
                    </template>
                </a-table>
                <div style="text-align: right;margin-top: 16px">
                    <a-pagination
                            :pageSizeOptions="pageSizeOptions"
                            :total="materialHistoryPageInfo.total"
                            showSizeChanger
                            showQuickJumper
                            :pageSize="materialHistoryPageInfo.pageSize"
                            v-model="materialHistoryPageInfo.current"
                            @showSizeChange="materialHistorySizeChange"
                            @change="materialHistoryChangePage">
                    </a-pagination>
                </div>
            </div>
            <template slot="footer">
                <a-button @click="materialHistoryModal = false">关闭</a-button>
            </template>
        </a-modal>
        <!--查看大图-->
        <a-modal
                v-model="previewImgModal"
                :footer="null"
                width="370px"
                :zIndex="1002">
            <div class="img-box">
                <img :src="previewUrl" alt="">
            </div>
        </a-modal>
        <!--查看视频-->
        <a-modal
                v-model="previewVideoModal"
                :footer="null"
                @cancel="handleCancel"
                width="370px"
                :zIndex="1002">
            <div class="video-box">
                <video ref="showMaterialVideo" :src="previewUrl" controls autoplay="autoplay" loop="loop"></video>
            </div>
        </a-modal>
    </div>
</template>

<script>
    import checkUpload from '../../commomFun/checkUploadFile';
    import {config} from '../../utils/config';
    import api from '../../commomFun/api'
    export default {
        name: "editPullIngPlanMaterial",
        inject: ['reload'],
        data() {
            return {
                userInfo: '',
                //上传
                header: {
                    token: "",
                    uid: ""
                },
                uploadMaterialImgUrl: config.uploadMaterialImgUrl,
                // 投放中更换物料
                changeMaterialModal: false,
                // 上传loading
                fullImgLoading: false,
                // 大图弹出框
                previewImgModal: false,
                previewUrl: '',
                previewVideoModal: false,
                // 更换物料历史
                pageSizeOptions: ['10', '20', '30', '40'],
                materialHistoryModal: false,
                materialHistoryPageInfo:{
                    pageTotal: 0,
                    pageSize: 10,
                    current: 1,
                },
                materialHistoryList: [],
                materialHistoryColumns:[
                    {
                        title: '备案时间',
                        key: 'auditTime',
                        dataIndex: 'auditTime',
                        width: 180,
                        scopedSlots: {customRender: 'auditTime'},
                    },
                    {
                        title: '换画前',
                        key: 'beforeUrl',
                        width: 100,
                        scopedSlots: {customRender: 'beforeUrl'},
                    },
                    {
                        title: '换画后',
                        key: 'afterUrl',
                        width: 100,
                        scopedSlots: { customRender: 'afterUrl' },
                    },
                    {
                        title: '备案结果',
                        key: 'auditResult',
                        width: 100,
                        scopedSlots: {customRender: 'auditResult'},
                    },
                    {
                        title: '备案意见',
                        key: 'auditMessage',
                        dataIndex: 'auditMessage',
                        width: 210,
                        scopedSlots: {customRender: 'auditMessage'},
                    }
                ],
            }
        },
        props:{
            // 修改物料
            playDuration : Number,
            changeMaterialList:{
                type: Array,
                required: true,
            },
            showHistory: {
                type: Boolean,
                required: true
            },
            adMaterialList: {
                type: Array,
                required: true,
            },
            planInfo: {
                type: Object,
                required: true
            }
        },
        watch: {
            changeMaterialList(newVal) {
                this.changeMaterialList = newVal;
                this.changeMaterialModal = true
            },
            showHistory(newVal) {
                this.showHistory = newVal;
                this.materialHistoryModal = true
                this.getMaterialHistory()
            }
        },

        mounted() {
            if(!this.planInfo.planId) {
                this.changeMaterialModal = false;
            }
            this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'));
            this.header.token = this.userInfo.token;
            this.header.uid = this.userInfo.userId;
        },

        methods:{
            //预览大图/视频
            previewMaterial(type, url) {
                this.previewUrl = url;
                if (type == 1) {
                    this.previewImgModal = true;
                } else {
                    this.previewVideoModal = true;
                    let timer = setTimeout(() => {
                        let video = this.$refs.showMaterialVideo;
                        video.play();
                        clearTimeout(timer)
                    },200)
                }
            },
            // 放大关闭
            handleCancel(){
                this.previewVideoModal = false;
                this.$refs.showMaterialVideo.pause();
            },
            changeMaterialDuration() {
                if(this.changeMaterialList[1].fileType === 3){
                    this.changeDelMaterial()
                }
            },
            // 删除待保存物料
            changeDelMaterial() {
                console.log('删除待保存物料',this.changeMaterialList[1]);
                let material = this.changeMaterialList[1];
                material.fileUrl = '';
                material.fileName = '';
                material.fileId = '';
                material.fileMd5 = '';
                // material.fullImageFileUrl = '';
                material.fileCryptUrl = ''
                material.videoSnapshotUrl = ''
            },
            // 上传校验
            beforeUploadFun(file) {
                return checkUpload.beforeFile(file,this.changeMaterialList[1].materialSize.w,this.changeMaterialList[1].materialSize.h,this.changeMaterialList[1].isDuration)
            },
            // 获取计划详情
            getPlanEditDetail(planID) {
                return new Promise(resolve => {
                    api
                    .postApi('/adPlan/getPlanEditDetail?planId=' + planID)
                    .then(res => {
                        if (res.data.code === 200) {
                            resolve(res.data.data)
                        }
                    })
                })
            },
            /**
             * 投放中更换物料为换画
             * 
             */
            async savePlan() {
                let material = this.changeMaterialList[1];
                if(!material.fileId) {
                    this.$message.warning('请先上传物料');
                    return
                }
                let uri = "",
                    params = {};
                if(this.planInfo.status === 2) {
                    // 换画
                    let ids = this.changeMaterialList[0].materialId;
                    uri = '/material/detail/saveReplace';
                    params = [];
                    for(let i = 0;i<ids.length;i++){
                        params.push({
                            "detailsId": this.changeMaterialList[0].id[i],
                            "materialId": ids[i],
                            "fileType": material.fileType,
                            "fileId": material.fileId,
                            "fileName": material.fileName,
                            "fileMd5": material.fileMd5,
                            "fileUrl": material.fileUrl,
                            "adSpace": 3,
                            "planId": this.planInfo.planId,
                            "fileCryptUrl": material.fileCryptUrl,
                            "videoSnapshotUrl": material.videoSnapshotUrl,
                        })
                    }
                } else {
                    uri = "/material/updateAdMaterialDetail";
                    params = {
                        planId: this.planInfo.planId,
                        materialIds: this.adMaterialList.map(item=>item.materialId),
                        adMaterialDetailRequest: {
                            adSpace: 3,
                            createUserId: JSON.parse(sessionStorage.userInfo).userId,
                            fileCryptUrl: material.fileCryptUrl,
                            fileId: material.fileId,
                            fileMd5: material.fileMd5,
                            fileName: material.fileName,
                            fileType: material.fileType,
                            fileUrl: material.fileUrl,
                            materialInfo: JSON.stringify(material.materialInfo),
                            status: 0,
                            type: 0,
                            videoSnapshotUrl: material.videoSnapshotUrl
                        }
                    }
                }
                api.postApi(uri, params)
                    .then(res => {
                        if (res.data.code === 200) {
                            this.changeMaterialModal = false;
                            // _this.reload()
                            this.$emit('getMaterialInfo')
                            // _this.$emit('closeChangeMaterial',1)
                        } else {
                            this.$message.warning(res.data.msg || '物料保存异常')
                        }
                    })
                    .catch(err => {
                        console.log('物料保存异常', err);
                    });
            },
            /**
             *  投放中更换物料历史
             * */
            // 投放中更换物料
            changeMaterialFun(info) {
                if (info.file.status === 'uploading') {
                    this.fullImgLoading = true;
                    return
                }
                if (info.file.status === 'done') {
                    this.fullImgLoading = false;
                    if(info.file.response.code === 200) {
                        let data = info.file.response.data;
                        let materialInfo = data.materialInfo;
                        let material = this.changeMaterialList[1];
                        if(data.fileType === 3 && (materialInfo.lengthInTime < material.isDuration ||
                            materialInfo.lengthInTime > (material.isDuration + 1))) {
                            this.$message.error('上传失败！请上传相应播放时长的视频！');
                            return;
                        }
                        material.planId = this.planInfo.planId;
                        material.fileType = data.fileType;
                        material.fileUrl = data.fileUrl;
                        material.fileName = data.fileName;
                        material.fileId = data.fileId;
                        material.fileMd5 = data.fileMd5;
                        material.adSpace = 3;			        // 1为上半屏，2为下半屏，3为下半屏+上半屏（也就是全屏）
                        material.fileCryptUrl = data.fileCryptUrl;
                        material.videoSnapshotUrl = data.videoSnapshotUrl;
                        material.materialInfo = materialInfo;
                    } else {
                        this.$message.warning(info.file.response.msg || '素材上传异常')
                    }
                }
            },
            // 获取物料历史数据
            getMaterialHistory(){
                let params = {
                    planId: this.planInfo.planId,
                    pageNum: this.materialHistoryPageInfo.current,
                    pageSize: this.materialHistoryPageInfo.pageSize
                }
                api.getApi('/material/detail/listMaterialReplace',params).then(res=>{
                    if(res.data.code === 200) {
                        this.materialHistoryList = res.data.data.list.map((item,index)=>{
                            return {
                                key: index,
                                auditTime: item.auditTime,
                                beforeUrl: item.preUrl,
                                afterUrl: item.url,
                                auditResult: item.status,
                                auditMessage: item.remark,
                            }
                        })
                        this.materialHistoryPageInfo.total = res.data.data.total
                    } else {
                        this.$message.warning(res.data.msg || '历史数据获取异常')
                    }
                }).catch(err =>{
                    console.log('历史物料err--',err)
                })
            },
            // 页条数
            materialHistorySizeChange(current, pageSize) {
                this.materialHistoryPageInfo.current = current;
                this.materialHistoryPageInfo.pageSize = pageSize;
                this.getMaterialHistory()
            },
            // 页数
            materialHistoryChangePage(page) {
                this.materialHistoryPageInfo.current = page;
                this.getMaterialHistory()
            },
            // 物料放大显示
            showHistoryMaterial(url) {
                console.log('url---',url);
                if(url.includes('.mp4')) {
                    this.previewMaterial(2,url)
                } else {
                    this.previewMaterial(1,url)
                }

            },
        }
    }
</script>

<style scoped lang="scss">
    /* 投放中更换物料 */
    .materialPushing {
        /deep/ .warn-box {
            .ant-alert-message {
                color: rgba(0, 0, 0, 0.65)
            }
        }
        .modal_content {
            border: 1px solid rgba(233, 233, 233, 1);
            margin-top: 16px;
            .radio {
                height: 62px;
                border-bottom: 1px solid rgba(233, 233, 233, 1);
                line-height: 62px;
                text-align: center;
                .ant-form-item {
                    margin-bottom: 0;
                    height: 100%;

                    .ant-form-item-label,
                    .ant-form-item-control {
                        line-height: 64px;
                    }
                }
            }
            .content_main{
                display: flex;
                justify-content: space-around;
                padding: 24px 0 0;
                min-height: 391px;
                .content_warp{
                    width: 264px;
                    border-radius: 8px;
                    .change_material_body{
                        width: 240px;
                        /*height: 390px;*/
                        margin:0 auto;
                        /*background: url("../../../public/images/fullMaterial.png") no-repeat;*/
                        background-size: contain;
                        position: relative;
                        /deep/ .ant-upload {
                            width: 100%;
                            margin: 0 auto;
                            position: relative;
                            /* top: 22px; */
                            height: 342px;
                            /*border: 1px dashed rgba(0,0,0,0.25);*/
                            border-radius: 0;
                        }

                        .m-updataing {
                            height: 220px;
                            padding-top: 40px;
                            .u-ant-upload-img {
                                margin: 0 auto;
                                width: 35px;
                                height: 28px;
                                font-size: 20px;

                                i {
                                    color: #1890FF;

                                    svg {
                                        width: 37px;
                                        height: 30px;
                                    }
                                }
                            }

                            .u-ant-upload-text {
                                font-size: 14px;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 0.85);
                                line-height: 22px;
                            }

                            .u-ant-upload-info {
                                font-size: 12px;
                                font-weight: 400;
                                color: rgba(0, 0, 0, 0.43);
                                line-height: 20px;
                            }
                        }

                        .m-updataed {
                            /*position: absolute;*/
                            /*top: 17px;*/
                            /*left: 21px;*/

                            .m-bg-img {
                                /*width: 222px;*/
                                /*height: 334px;*/
                                cursor: pointer;

                                img {
                                    width: 240px;
                                    /*height: 100%;*/
                                }

                                video {
                                    width: 100%;
                                    height: 100%;
                                    cursor: pointer;
                                }
                            }

                            .m-img-info {
                                position: absolute;
                                top: 0;
                                /*width: 222px;*/
                                /*height: 334px;*/

                                .u-ant-upload-img {
                                    position: relative;
                                    margin: 0px auto 12px;
                                    padding-top: 121px;
                                    width: 35px;
                                    height: 28px;
                                    font-size: 20px;
                                    box-sizing: content-box;

                                    i {
                                        position: absolute;

                                        &:first-child {
                                            color: #1890FF;

                                            svg {
                                                width: 37px;
                                                height: 30px;
                                            }
                                        }

                                        &:last-child {
                                            bottom: -2px;
                                            right: -2px;
                                            color: #52C41A;

                                            svg {
                                                width: 14px;
                                                height: 14px;
                                            }
                                        }
                                    }
                                }

                                .u-ant-upload-text {
                                    font-size: 14px;
                                    /*font-family: PingFangSC-Regular;*/
                                    font-weight: 400;
                                    color: rgba(0, 0, 0, 0.85);
                                    line-height: 22px;
                                    text-align: center;
                                    margin-bottom: 10px;
                                }

                                .u-ant-upload-info {
                                    font-size: 12px;
                                    /*font-family: PingFangSC-Regular;*/
                                    font-weight: 400;
                                    color: rgba(0, 0, 0, 0.43);
                                    line-height: 20px;
                                    text-align: center;
                                }

                                .u-clost-updata {
                                    position: absolute;
                                    top: -10px;
                                    right: -10px;
                                    width: 20px;
                                    height: 20px;
                                    cursor: pointer;
                                    color: #de2c2c;

                                    svg {
                                        width: 100%;
                                        height: 100%;
                                    }
                                }
                            }
                        }
                    }
                    > span{
                        width: 126px;
                        height: 32px;
                        line-height: 32px;
                        border-radius: 17px;
                        display: block;
                        background: rgba(239, 239, 239, 1);
                        margin: 24px auto 16px;
                        text-align: center;
                        font-size: 14px;
                        color: rgba(0,0,0,0.65);
                    }
                    .span_new{
                        background: rgba(24, 144, 255, 0.15);
                        color: rgba(24, 144, 255, 1);
                    }
                }
            }
        }
    }
    .material_history_table{
        .show_btn{
            cursor: pointer;
            color: #1890ff;
        }
    }

    .img-box,.video-box {
        text-align: center;
    }

    .img-box img{
        width: 320px;
        height: auto;
    }

    .video-box video {
        width: 320px;
        height: auto;
    }
</style>